<script>
// 该组件的作用是根据不同的屏幕尺寸分发不同的显示内容
import { mapState } from 'vuex';
export default {
    name: 'switch-device',
    data() {
        return {
            slots: [] // 具名slot的名称
        };
    },
    computed: {
        ...mapState({
            windowSize: (state) => state.common.windowSize // 以600为界限区分mobile和pc
        })
    },
    methods: {
        cloneVNode(vnode) {
            const cloned = new vnode.constructor(
                vnode.tag,
                vnode.data,
                vnode.children && vnode.children.slice(),
                vnode.text,
                vnode.elm,
                vnode.context,
                vnode.componentOptions,
                vnode.asyncFactory
            );
            cloned.ns = vnode.ns;
            cloned.isStatic = vnode.isStatic;
            cloned.key = vnode.key;
            cloned.isComment = vnode.isComment;
            cloned.fnContext = vnode.fnContext;
            cloned.fnOptions = vnode.fnOptions;
            cloned.fnScopeId = vnode.fnScopeId;
            cloned.asyncMeta = vnode.asyncMeta;
            // cloned.isCloned = true;
            return cloned;
        },
        getSlots() {
            const reg = /^device_(\d*)$/;
            const slots = Object.keys(this.$slots)
                .filter((slotName) => {
                    return reg.test(slotName);
                })
                .map((slotName) => {
                    let match = slotName.match(reg);
                    if (match && Number(match[1])) {
                        return Number(match[1]);
                    } else {
                        throw new Error('switch-device 具名插槽错误');
                    }
                })
                .sort((a, b) => a - b);
            this.slots = [0, ...slots];
        },
        renderVnode() {
            const { width } = this.windowSize;
            let index = 0;
            // 找到屏幕宽度在哪个区间
            for (let i = 0, len = this.slots.length; i < len; i++) {
                let w = this.slots[i];
                let nw = this.slots[i + 1];
                if (!nw) return this.$slots.default; // 越界了,取default
                if (width > w && width <= nw) {
                    index = i + 1;
                    break;
                }
            }
            return this.$slots[`device_${this.slots[index]}`];
        }
    },
    render(createElement) {
        if (!this.hasGetSlots) {
            this.getSlots();
            this.hasGetSlots = true;
        }
        const node = this.renderVnode();
        if (Array.isArray(node) && node.length > 1) {
            throw new Error(
                'only one root node is allowed in switch-device slot template'
            );
        }
        return this.cloneVNode(Array.isArray(node) ? node[0] : node);
    }
};
</script>
